'use client';

import { useEffect } from 'react';

/**
 * Disables console.log, console.info, and console.debug on the client side.
 * Keeps console.warn and console.error for error tracking.
 *
 * This component should only be rendered in production to avoid polluting
 * the browser console with debug information while preserving error logging.
 */
export function DisableConsoleLogs() {
  useEffect(() => {
    const noop = () => {};
    console.log = noop;
    console.info = noop;
    console.debug = noop;
  }, []);

  return null;
}
